module.exports = __webpack_public_path__ + "static/img/far1_active.20c94322.png";